import { Iterable, pipe } from '@blade/std-lib'

type RpcDef = {
  id: string
  label: string
  pingUrl: string
}

export const Default = {
  id: 'default',
  label: 'Default',
  pingUrl: 'https://sender.helius-rpc.com/ping',
} as const satisfies RpcDef

export const Slc = {
  id: 'slc',
  label: 'Salt Lake City',
  pingUrl: 'http://slc-sender.helius-rpc.com/ping',
} as const satisfies RpcDef

export const Ewr = {
  id: 'ewr',
  label: 'Newark',
  pingUrl: 'http://ewr-sender.helius-rpc.com/ping',
} as const satisfies RpcDef

export const Lon = {
  id: 'lon',
  label: 'London',
  pingUrl: 'http://lon-sender.helius-rpc.com/ping',
} as const satisfies RpcDef

export const Fra = {
  id: 'fra',
  label: 'Frankfurt',
  pingUrl: 'http://fra-sender.helius-rpc.com/ping',
} as const satisfies RpcDef

export const Ams = {
  id: 'ams',
  label: 'Amsterdam',
  pingUrl: 'http://ams-sender.helius-rpc.com/ping',
} as const satisfies RpcDef

export const Sg = {
  id: 'sg',
  label: 'Singapore',
  pingUrl: 'http://sg-sender.helius-rpc.com/ping',
} as const satisfies RpcDef

export const Tyo = {
  id: 'tyo',
  label: 'Tokyo',
  pingUrl: 'http://tyo-sender.helius-rpc.com/ping',
} as const satisfies RpcDef

export type HeliusRpc =
  | typeof Default
  | typeof Slc
  | typeof Ewr
  | typeof Lon
  | typeof Fra
  | typeof Ams
  | typeof Sg
  | typeof Tyo

export type RpcId = HeliusRpc['id']

export const all = [Default, Slc, Ewr, Lon, Fra, Ams, Sg, Tyo]
export const byId = pipe(
  all,
  Iterable.toRecord((it) => it.id),
)
